import { createContext, useContext } from 'react';
const CustomVisualOverlayContext = createContext(null);
/**
 * Provider that allows va-react-core consumers to render a custom component over visual.
 *
 * The provided component gets rendered as a sibling of each visual in relatively or absolutely positioned wrapper element.
 */
export const CustomVisualOverlayProvider = CustomVisualOverlayContext.Provider;
export function useCustomVisualOverlay() {
    return useContext(CustomVisualOverlayContext);
}
const CustomReportAreaOverlayContext = createContext(null);
/**
 * Provider that allows va-react-core consumers to render a custom component over report areas that contain multiple visuals.
 *
 * Report areas include prompt headers, sections, and prompt container popups. The provider component gets rendered as a
 * sibling of the report area in relatively positioned wrapper element.
 */
export const CustomReportAreaOverlayProvider = CustomReportAreaOverlayContext.Provider;
export function useCustomReportAreaOverlay() {
    return useContext(CustomReportAreaOverlayContext);
}
